import {
  SLowcodeList,
  STableActions,
  SActionBtn,
  SFuncModal,
  SFuncModalFormRef,
} from 'shj-components'
import { useEffect, useRef, useState } from 'react'
import { Spin } from 'antd'
import { cloneDeep } from 'lodash-es'
import { InputSpecsModal } from '../../components/InputSpecsModal'

export const SKUConfigTable = props => {
  const { columnsConfig = [], data = [], loading = false, setState = () => ({}) } = props
  const specsRef = useRef<SFuncModalFormRef>({ onFinish: undefined })
  const listRef = useRef()
  const [config, setConfig] = useState<any>({
    fieldControl: false,
    rowSelection: true,
    columns: [],
    batchActions: [
      {
        label: '批量配置输入参数',
        type: 'primary',
        events: ['onClick:handleOpenMultipleArgModal'],
      },
    ],
    search: false,
  })

  useEffect(() => {
    console.log(data, '表格数据')
    let newArray = data.map((item, index) => {
      return {
        ...item,
        ...item.argMap,
      }
    })
    listRef.current?.updateDataSource(newArray, newArray.length)
  }, [data])

  useEffect(() => {
    if (columnsConfig.length) {
      console.log(columnsConfig, '表头数据')
      const columns = columnsConfig.map(item => {
        return {
          title: item.label,
          dataIndex: [item.argCode, 'valueName'],
          width: 200,
          ellipsis: true,
          render: (text, record) => {
            return text || '不限'
          },
        }
      })
      setConfig({
        ...config,
        columns: [
          {
            title: 'SKU序号',
            dataIndex: 'id',
            width: 200,
            ellipsis: true,
          },
          ...columns,
          {
            title: '输入型参数',
            dataIndex: 'inputArgList',
            render: text => <span>{text?.map(item => item.argName)?.join('，') || ''}</span>,
            width: 400,
            ellipsis: {
              showTitle: true,
            },
          },
          {
            title: '操作',
            dataIndex: '#',
            render: 'actionRender',
            fixed: 'right',
            width: 200,
          },
        ],
      })
    }
  }, [columnsConfig])

  const handleSpecs = (argList = [], editId = '') => {
    const newData = cloneDeep(data)?.map((item: any) => {
      if (item.id === editId) {
        return {
          ...item,
          inputArgList: argList,
        }
      }
      return {
        ...item,
      }
    })
    setState({ dataSource: newData })
  }

  const handleMultipleSpecs = (argList = [], editIdList = []) => {
    const newData = cloneDeep(data)?.map((item: any) => {
      if (editIdList?.includes(item.id)) {
        return {
          ...item,
          inputArgList: argList,
        }
      }
      return {
        ...item,
      }
    })
    setState({ dataSource: newData })
  }

  const handleOpenArgModal = (record: any) => {
    SFuncModal({
      title: '输入型参数',
      formRef: specsRef.current,
      content: (
        <InputSpecsModal
          formRef={specsRef}
          addInputArg={record.inputArgList}
          fn={handleSpecs}
          editId={record.id}
          multiple={false}
        />
      ),
    })
  }

  const handleOpenMultipleArgModal = (record: any) => {
    SFuncModal({
      title: '输入型参数',
      formRef: specsRef.current,
      content: (
        <InputSpecsModal
          formRef={specsRef}
          fn={handleMultipleSpecs}
          editIdList={record?.selectedRowKeys}
          multiple={true}
        />
      ),
    })
  }

  const extensions = {
    events: { handleOpenMultipleArgModal },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => handleOpenArgModal(record)}>输入型参数配置</SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (
    <Spin spinning={loading}>
      <SLowcodeList ref={listRef} searchMode={'group'} config={config} {...extensions} />
    </Spin>
  )
}
